import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './ModalPreviewSelectedPhoto.module.scss';
import {modalPreviewSelectedPhotoActions} from "../../store/slices/modalPreviewSelectedPhotoSlice";

const ModalPreviewSelectedPhoto = ({photo, component}) => {
    const dispatch = useDispatch();
    const {sourceComponent} = useSelector(state => state.modalPreviewSelectedPhoto);

    const handleCloseModal = () => {
        dispatch(modalPreviewSelectedPhotoActions.closePreview());
    };

    if (component !== sourceComponent) {
        return null;
    }

    return (
        <div
            className={styles.modalPreviewSelectedPhoto}
            onClick={handleCloseModal}
        >

            <span
                className={styles.close}
                onClick={handleCloseModal}
            >×</span>
            <img
                className={styles.modalPreviewSelectedPhoto_content}
                src={photo}
                alt={'photo'}/>
        </div>
    );
};

export default ModalPreviewSelectedPhoto;
